/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

import { types } from 'mobx-state-tree';

/**
 * A basic model that can be used with the Tabs react component from the UI-toolkit.
 * It simply manages the state of which tab to display.
 */

export default types
	.model('TabsModel', {
		tab: types.string
	})
	.views((self) => ({
		getTab() {
			return self.tab;
		}
	}))
	.actions((self) => ({
		showTab(id) {
			self.tab = id;
		}
	}));



// WEBPACK FOOTER //
// ./src/js/components/tabs/TabsModel.js